var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { borderRadius, color, elevation, spacing, divider } from '../../constants';
/**
 * Provides the frame a header.
 */
export var FrameHeader = styled.header(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", ";\n  background-color: transparent;\n  border-bottom: 1px solid ", ";\n"], ["\n  padding: ", ";\n  background-color: transparent;\n  border-bottom: 1px solid ", ";\n"
    /**
     * Provides the frame a footer.
     */
])), spacing.default, divider.solid);
/**
 * Provides the frame a footer.
 */
export var FrameFooter = styled.footer(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", ";\n  background-color: ", ";\n  border-top: 1px solid ", ";\n"], ["\n  padding: ", ";\n  background-color: ", ";\n  border-top: 1px solid ", ";\n"
    /**
     * Provides a content block for the frame. Child components of FrameContent should implement
     * their own padding and margin as necessary as it does not impose padding or margin.
     */
])), spacing.default, color.theme.supportingColor.tint, divider.solid);
/**
 * Provides a content block for the frame. Child components of FrameContent should implement
 * their own padding and margin as necessary as it does not impose padding or margin.
 */
export var FrameContent = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex-grow: 1;\n  display: flex;\n  flex-wrap: wrap;\n"], ["\n  flex-grow: 1;\n  display: flex;\n  flex-wrap: wrap;\n"])));
export var StyledFrame = styled.section(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  overflow: auto;\n  min-height: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  overflow: auto;\n  min-height: ",
    ";\n"
    /**
     * `Frame` is a primary container and wraps a header, a content, and a footer as below. The `fullFrame` flag sets the minimum height of frame to the viewport height. In addition, an offset can be set using `heightOffset` property to reduce the height as needed.
     *
     * ### FrameContent
     * Child components of `FrameContent` should implement their own padding and margin as necessary as it does not impose padding or margin.
     *
     * ### FrameHeader
     * This component provides a header element for the frame.
     *
     * ### FrameFooter
     * This component provides a footer element for the frame.
     */
])), color.pureWhite, borderRadius.large, elevation.content, function (_a) {
    var fullFrame = _a.fullFrame, heightOffset = _a.heightOffset;
    return fullFrame !== undefined && fullFrame && heightOffset !== undefined
        ? "calc(100vh - " + heightOffset + ")"
        : 'initial';
});
/**
 * `Frame` is a primary container and wraps a header, a content, and a footer as below. The `fullFrame` flag sets the minimum height of frame to the viewport height. In addition, an offset can be set using `heightOffset` property to reduce the height as needed.
 *
 * ### FrameContent
 * Child components of `FrameContent` should implement their own padding and margin as necessary as it does not impose padding or margin.
 *
 * ### FrameHeader
 * This component provides a header element for the frame.
 *
 * ### FrameFooter
 * This component provides a footer element for the frame.
 */
export var Frame = function (props) {
    var children = props.children, rest = __rest(props, ["children"]);
    return React.createElement(StyledFrame, __assign({}, rest), children);
};
Frame.defaultProps = {
    fullFrame: false,
    heightOffset: '0px'
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map